module.exports = __webpack_public_path__ + "img/delete_red.d16dc645.svg";